export const ru = {
    'allowed-page-id-is-not-number':
        'pageId должно быть положительным числом, ошибки в значениях: {values}',
    'allowed_page-ids-limit-reached':
        'общее количество запрещенных pageId не может превышать: {limit}',
    and: 'и',
    'banned-domains-limit-reached':
        'Максимальное количество площадок/внешних сетей: {limit}',
    'empty-campaign-name': 'Не указано название кампании',
    experiments: 'Экспериментов',
    'invalid-disabled-ips-number':
        'Общее количество запрещенных IP-адресов не может превышать {maxIpsNumber}',
    'invalid-ips': 'Неверно указаны IP-адреса: {ips}',
    'key-goals': 'Ключевых целей',
    'max-length-name': 'Название кампании не должно превышать {count} символов',
    'metrika-counters-is-unavailable': {
        one:
            'Счетчик метрики {counters} был удален и не может быть привязан к кампании',
        some:
            'Счетчики метрики {counters} были удалены и не могут быть привязаны к кампании',
        many:
            'Счетчики метрики {counters} были удалены и не могут быть привязаны к кампании',
        none:
            'Счетчики метрики {counters} были удалены и не могут быть привязаны к кампании'
    },
    'warning-about-metrika-counters':
        'При удалении счетчиков, потеряются все настройки {fields} по соответствующим целям'
};
